
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/mcp",
      function () {
        return require("private-next-pages/developer/mcp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/mcp"])
      });
    }
  